
import page from "~/layouts/testimonial.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Création d’une campagne Facebook Ads pour un apiculteur - ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Apiculteur, ce professionnel s'est tourné vers ALEO pour la création et la gestion de sa page Facebook professionnelle. Résultat : Visibilité boostée !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Création d’une campagne Facebook Ads pour un apiculteur - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Spécialisé dans l’apiculture, ce professionnel s'est tourné vers ALEO pour la création et la gestion de sa page Facebook professionnelle. Résultat : Visibilité boostée !",
        },
      ],
    };
  },
};
